<template>
  <div>
    <div class="plate plate-top">
      <div class="left-side">
        <div class="panel panel-map">
          <div id="googleMap" class="map">
            <google :width="100" :height="854" :title="title" :url="url" :spanList="spanList" :state="4" ref='maps'></google>
          </div>
        </div>
        <div class="panel box_style1 panel-region mt18">
          <div class="title"><span>各地区补贴进度</span><span class="small">单位：万元</span></div>
          <region-chart/>
        </div>
      </div>
      <div class="right-side">
        <div class="panel box_style1 panel-money">
          <div class="title">作业补贴资金</div>
          <div id="moneyChart" class="money-chart"></div>
        </div>
        <div class="panel box_style1 panel-job mt18">
          <div class="title">
            <span>作业补贴统计</span>
            <span v-if="jobSubsidyType==1" class="small">单位：台/套</span>
            <span v-else-if="jobSubsidyType==2" class="small">单位：亩</span>
            <span v-else class="small">单位：万元</span>
          </div>
          <job-chart @fnType="getFnType"/>
        </div>
      </div>
    </div>
    <div class="plate plate-center">
      <div class="left-side">
        <div class="panel box_style1 mt18">
          <div class="title">
            <span>各作业类型占比</span>
            <p class="toggle">
              <span @click="changeJobTypeProportion(1)" :class="idx==1?'active':''">补贴资金</span>
              <span @click="changeJobTypeProportion(2)" :class="idx==2?'active':''">作业面积</span>
            </p>
          </div>
          <div class="flex">
            <div id="typePieChart" class="type-pic-chart"></div>
            <div id="typeBarChart" class="type-bar-chart"></div>
          </div>
          <div class="unit">{{idx==1?'补贴资金（万元）':'作业面积（亩）'}}</div>
        </div>
      </div>
      <div class="right-side">
        <div class="panel box_style1 mt18">
          <div class="title">
            <span>各作业类型补贴进度</span>
            <div>
              <select class="select-type" v-model="selectedJobType" @change="changeJobType">
                <option v-for="item in jobTypeList" :value="item.workType" :key="item.workType">{{item.workTypeName}}</option>
              </select>
            </div>
          </div>
          <div id="typeProgressChart" class="type-progress-chart"></div>
        </div>
      </div>
    </div>
    <div class="plate plate-bottom">
      <div class="panel box_style1 panel-all mt18">
        <div class="title">各地区服务组织、机手数量、机具分布</div>
        <div id="jobALLChart" class="job-all-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
/*import google from '../../components/Comment/googlemap.vue'*/
// import google from '../../components/Comment/Tianmap.vue'
// import JobChart from '../../components/Comment/JobChart.vue'

import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
import google from './googlemap.vue'
import RegionChart from './RegionChart.vue'
import JobChart from './JobChart.vue'
export default {
  name: 'JobSubsidy',
  components: {
    google,
    JobChart,
    RegionChart
  },
  data () {
    return {
      idx: 1, //类型占比，默认补贴资金
      jobSubsidyType: 1, //作业补贴统计类型，默认机具数量
      title: '作业补贴机具地图分布',
      spanList: [{name: '全部', value: ''}, {name: '运行农机', value: 1}, {name: '静止农机', value: 0}, {name: '作业农机', value: 2}],
      url: '/workSubsidy/workSubMapDistri', //作业补贴机具地图分布接口
      moneyChart: '', //作业补贴资金
      moneyChartdata: {}, //作业补贴资金数据
      typePieChart: '', //各作业类型占比饼状图
      typePieData: [], //各作业类型占比饼状图数据
      typeBarChart: '', //各作业类型占比柱状图
      typeBarData: {}, //各作业类型占比柱状图数据
      typeProgressChart: '', //各作业类型补贴进度
      typeProgressData: [], //各作业类型补贴进度数据
      selectedJobType: '', //作业类型选中项
      jobTypeList: [], //各作业类型数据
      jobALLData: {}//服务组织、机手数量、机具分布数据
    }
  },
  created () {
    // this.selectedJobType = this.jobTypeList[0].id;
  },
  mounted () {
    // document.querySelector('body').setAttribute('style', 'background:#06041c')
    //this.loadScript()
    this.getSubsidydata()
    // this.getMoneyChart();
    // this.getTypePieChart()
    // this.getTypeBarChart()
    // this.getTypeProgressChart()
    // this.getJobALLChart()
    this.getWorkTypeList()
    this.$refs.maps.initMapTalk()
  },
  methods: {
    numToAry (n) {
      var str = n + ''
      var arr = []
      str.split('').forEach(function (item) {
        arr.push(parseInt(item))
      })
      return arr
    },
    getFnType (data) {
      this.jobSubsidyType = data
    },
    getMoneyChart () {
      this.moneyChart = this.$echarts.init(document.getElementById('moneyChart'))
      this.moneyChart.setOption({
        calculable: true,
        // title:{
        //   text: this.moneyChartdata.susidedProportion,
        //   top: 'center',
        //   left:'16%',
        //   x:'center',
        //   textStyle:{
        //     color: '#de2a87',
        //     fontStyle: 'normal',
        //     fontWeight: 'bold',
        //     fontFamily: 'sans-serif',
        //     fontSize: 18,
        //   }
        // },
        tooltip: {
          // trigger: 'item',
          formatter: '{a}{b}：<br/> {c}万 ({d}%)'
        },
        color: ['#2b56c3', '#de2a87'], //调色盘颜色列表
        legend: {
          orient: 'vertical',
          x: '60%',
          y: window.screen.width < 1500 ? "10%" :  '15%',
          itemWidth: 16,
          itemHeight: 16,
          itemGap: window.screen.width < 1500 ? 10 : 30,
          formatter: (name) => {
            let data = this.moneyChartdata.susides
            let val = 0
            for (var i = 0, l = data.length; i < l; i++) {
              if (data[i].name == name) {
                val = data[i].value
                // var num = (val || 0).toString();
                // var result = '';
                // while (num.length > 3) {
                //   result = ',' + num.slice(-3) + result;
                //   num = num.slice(0, num.length - 3);
                // }
                // if (num) { result = num + result; }
              }
            }
            let arr = [
              '{a|' + name + '}',
              '{b|' + val + '万}'
            ]
            return arr.join('\n')
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 16,
                padding: [63, 0, 20, 0]
              },
              b: {
                color: '#fff',
                fontSize: 20,
                lineHeight: 40,
                padding: [-10, 0, 30, 0]
              }
            }
          },
          data: [
            {name: '剩余补贴资金总额',
              icon: 'rect',
              textStyle: {
                color: '#2b56c3'
              }},
            {name: '已补贴资金总额',
              icon: 'rect',
              textStyle: {
                color: '#de2a87'
              }}]
        },
        series: [
          // {
          //   name: '作业补贴资金',
          //   type: 'pie',
          //   radius: ['50%', '80%'],
          //   center: ['25%', '50%'], //饼图的（圆心）坐标,数组的第一项是横坐标，第二项是纵坐标
          //   avoidLabelOverlap: false,
          //   label: {// 饼图图形上的文本标签
          //     normal: {//图形在默认状态下的样式
          //       show: true,
          //       textStyle: {
          //         color: '#de2a87',
          //         fontSize: '18',
          //         fontWeight: 'bold'
          //       }
          //     },
          //     emphasis: {
          //       show: true
          //       // textStyle: {
          //       //   fontSize: '16',
          //       //   fontWeight: 'bold'
          //       // }
          //     }
          //   },
          //   labelLine: {
          //     normal: {
          //       show: false
          //     }
          //   },
          //   itemStyle: {//显示在圆环中心
          //     normal: {
          //       label: {
          //         show: true,
          //         // position: 'center',
          //         // formatter: (param) => {
          //         //   return this.moneyChartdata.susidedProportion
          //         // },
          //         // textStyle: {
          //         //   color: '#fff'
          //         // }
          //       },
          //       labelLine: { show: false }
          //     },
          //     emphasis: {
          //       label: {
          //         show: false
          //       }
          //     }
          //   },
          //   data: this.moneyChartdata.susides
          // }
          {
            name: '',
            type: 'pie',
            radius: ['35%', '55%'],
            center: ['25%', '42%'], //饼图的（圆心）坐标,数组的第一项是横坐标，第二项是纵坐标
            avoidLabelOverlap: false,
            label: {
              show: true,
              color: '#fff'
            },
            // label: {
            //   normal: {
            //     show: true,
            //     position: 'outside',
            //     // textStyle: {
            //     //   fontSize: 16
            //     // },
            //     // formatter(v) {
            //     //   let text = v.name
            //     //   if(text.length <= 4) {
            //     //     return text;
            //     //   } else if(text.length > 4) {
            //     //     return text = `${text.slice(0,4)}\n${text.slice(4)}`
            //     //   }
            //     // }
            //   },
            //   emphasis: {
            //     show: true,
            //     textStyle: {
            //       fontSize: 16,
            //       fontWeight: 'bold'
            //     }
            //   }
            // },
            labelLine: {
              normal: {
                show: true,
                length: 10,
                length2: 10,
                // lineStyle: {
                //   color: '#f00'
                // }
              }
            },
            data: this.moneyChartdata.susides
          }
        ]
      })
      window.addEventListener('resize', () => { this.moneyChart.resize() })
    },
    getTypePieChart () {
      this.typePieChart = this.$echarts.init(document.getElementById('typePieChart'))
      this.typePieChart.setOption({
        calculable: true,
        tooltip: {
          trigger: 'item',
          formatter: params => {
            let unit = this.idx == 1 ? '万' : '亩'
            return params.seriesName + '<br/>' + params.name + ': ' + params.value + unit + ' (' + params.percent + '%)'
          }
        },
        grid: {
          top: '10%',
          bottom: '1%',
          left: '10%',
          right: '10%',
          containLabel: true

        },
        color: ['#50bdcb', '#db4545', '#4dc58e', '#ffad05', '#eaea26', '#50e5e3'], //调色盘颜色列表
        series: [
          {
            name: '作业类型占比',
            type: 'pie',
            radius: '55%',
            // avoidLabelOverlap: false,
            data: this.typePieData,
            label: {
              show: true,
              color: '#fff',
              fontSize: 16,
              formatter: params => {
                let unit = this.idx == 1 ? '万' : '亩'
                return params.value + unit
              }
              // normal: {
              //   formatter: params => {
              //     let unit = this.idx == 1 ? '万' : '亩'
              //     return params.value + unit
              //   }
              // },
              // emphasis: {
              //   show: true,
              //   textStyle: {
              //     fontSize: '16',
              //     // fontWeight: 'bold'
              //   }
              // }
            },
            // itemStyle: {
            //   normal: {
						// 		label: {
            //       show: true, //开启显示
            //       textStyle: {
            //         fontSize: 16
            //       }
            //     }
            //   },
            //   emphasis: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //   }
            // }
          }
        ]
      })
      window.addEventListener('resize', () => { this.typePieChart.resize() })
    },
    getTypeBarChart () {
      this.typeBarChart = this.$echarts.init(document.getElementById('typeBarChart'))
      var seriesLabel = {
        normal: {
          show: true,
          textBorderColor: '#333',
          textBorderWidth: 2
        }
      }
      this.typeBarChart.setOption(
        {
          tooltip: {
            trigger: 'axis',
            textStyle: {
              align: 'left'
            },
            formatter: params => {
              let unit = this.idx == 1 ? '万' : '亩'
              return params[0].name + '<br/>' + params[0].marker + params[0].seriesName + ':' + params[0].value + unit + '<br/>' + params[1].marker + params[1].seriesName + ':' + params[1].value + unit
            },
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: '0%',
            left: '5%',
            right: '4%',
            bottom: '-0%',
            containLabel: true
          },
          xAxis: {
            splitLine: {
              show: false
            },
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLine: {
              lineStyle: {
                color: '#0837c9'
              }
            },
            axisLabel: {
              interArrival: 0,
              textStyle: {
                color: '#fff',
                fontSize: 16
              }
            }
          },
          yAxis: {
            splitLine: {
              show: false
            },
            type: 'category',
            nameLocation: 'center',
            nameTextStyle: {
              color: '#60CAF1',
              fontSize: 16
            },
            nameStyle: {
              //文字颜色
              color: '#75C3FF'
            },
            axisLabel: {
              interArrival: 0,
              textStyle: {
                color: '#fff',
                fontSize: 16
              }
            },
            data: this.typeBarData.typeBarName,
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            },
            //去掉刻度线
            axisTick: {
              show: false
            }
          },
          series: [
            {
              name: this.idx == 1 ? '总金额' : '总作业面积',
              barWidth: 16, //柱图宽度
              type: 'bar',
              label: {//Y坐标数值显示；
                normal: {
                  show: false
                },
                seriesLabel
              },
              barGap: '-100%',
              data: this.typeBarData.typeBarTotalMoney,
              itemStyle: {
                normal: {
                  color: '#0e176b'
                }
              }
            },
            {
              name: this.idx == 1 ? '已使用金额' : '已补贴作业面积',
              barWidth: 16, //柱图宽度
              type: 'bar',
              label: {//Y坐标数值显示；
                normal: {
                  show: false
                },
                seriesLabel
              },
              data: this.typeBarData.typeBarCurMoney,
              itemStyle: {
                normal: {
                  color: '#0c85e3'
                }
              }
            }
          ]
        })
      window.addEventListener('resize', () => { this.typeBarChart.resize() })
    },
    getTypeProgressChart () {
      this.typeProgressChart = this.$echarts.init(document.getElementById('typeProgressChart'))
      this.typeProgressChart.setOption({
        calculable: true,
        tooltip: {
          // trigger: 'item',
          formatter: '{a} <br/>{b}: {c}万 ({d}%)'
        },
        grid: {
          top: '10%', //距离容器上边界
          bottom: '1%', //距离容器下边界
          left: '0%',
          right: '0%',
          containLabel: true

        },
        color: ['#0c9be3','#0fb9aa', '#e3195c', '#e2bf00', '#6db90a'], //调色盘颜色列表
        legend: {
          orient: 'vertical',
          left: '70%',
          top: window.screen.width < 1500 ? '8%' : '15%',
          bottom: 20,
          itemGap: window.screen.width < 1500 ? 10 : 15,
          itemWidth: window.screen.width < 1500 ? 15 : 20,
          itemHeight: window.screen.width < 1500 ? 10 : 10,
          textStyle: {
            fontSize: window.screen.width < 1500 ? 14 : 16,
          },
          data: [
            {name: '待审核',
              icon: 'rect',
              textStyle: {
                color: '#0c9be3'
              }},
            {name: '待打表',
              icon: 'rect',
              textStyle: {
                color: '#0fb9aa'
              }},
            {name: '公示中',
              icon: 'rect',
              textStyle: {
                color: '#e3195c'
              }},
            {name: '待结算',
              icon: 'rect',
              textStyle: {
                color: '#e2bf00'
              }},
            {name: '已结算',
              icon: 'rect',
              textStyle: {
                color: '#6db90a'
              }}

          ]
        },
        series: [
          {
            name: '作业类型补贴进度',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['35%', '50%'],
            // avoidLabelOverlap: true, //文字重叠
            label: {
              show: true,
              color: '#fff',
              fontSize: 16,
              formatter: '{c}万'
              // normal: {
              //   textStyle: {
              //     fontSize: 16
              //   },
              //   position: 'outside',
              //   formatter: '{c}万'
              // },
            },
            // label: {
            //   normal: {
            //     textStyle: {
            //       fontSize: 16
            //     },
            //     position: 'outside',
            //     formatter: '{c}万'
            //   },
            //   emphasis: {
            //     show: true,
            //     textStyle: {
            //       fontSize: '16',
            //       fontWeight: 'bold'
            //     }
            //   }
            // },
            data: this.typeProgressData
          }
        ]
      })
      window.addEventListener('resize', () => { this.typeProgressChart.resize() })
    },
    getJobALLChart () {
      this.jobALLChart = this.$echarts.init(document.getElementById('jobALLChart'))
      this.jobALLChart.setOption({
        tooltip: {
          trigger: 'axis',
          textStyle: {
            align: 'left'
          }
        },
        legend: {
          textStyle: {
            fontSize: 16
          },
          data: [
            {name: '服务组织',
              textStyle: {
                color: '#ec7d27'
              }},
            {name: '机手',
              textStyle: {
                color: '#d6e00c'
              }},
            {name: '机具',
              textStyle: {
                color: '#086fc9'
              }}
          ]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLine: {//坐标轴线
            lineStyle: {
              color: '#283b85',
              fontSize: '14'
            }
          },
          axisLabel: {
            interArrival: 0,
            // rotate: -30,
            textStyle: {
              color: '#fff',
              fontSize: 16
            }
          },
          data: this.jobALLData.xDataJobALL,
          axisTick: { //去掉刻度线
            show: false
          }
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisLine: {
            show: false,
            lineStyle: {color: '#fff', fontSize: '14'}
          },
          splitLine: {
            lineStyle: {color: ['#283b85']}
          },
          axisLabel: {
            interArrival: 0,
            textStyle: {
              color: '#fff',
              fontSize: 16
            }
          },
          axisTick: {show: false}
        },
        series: [
          {name: '服务组织',
            type: 'line',
            data: this.jobALLData.yDataJobALL.orgList,
            itemStyle: {
              normal: {color: '#ec7d27'}
            }
          },
          {name: '机手',
            type: 'line',
            data: this.jobALLData.yDataJobALL.driverList,
            itemStyle: {
              normal: {color: '#d6e00c'}
            }
          },
          {name: '机具',
            type: 'line',
            data: this.jobALLData.yDataJobALL.deviceList,
            itemStyle: {
              normal: {color: '#086fc9'}
            }
          }
        ]
      })
      window.addEventListener('resize', () => { this.jobALLChart.resize() })
    },
    /**
     * 切换作业类型占比
     * @param {number} workTypeStatus 作业类型状态
     */
    changeJobTypeProportion (num) {
      this.idx = num
      let params = {
        workTypeStatus: num
      }
      Api.doPost(Http.workSubsidy.workTypeProportion, params, false, (res) => {
        let data = res.result
        this.typePieData = []
        let typeBarCurMoney = [], typeBarTotalMoney = [], typeBarName = []
        if (params.workTypeStatus == 1) {
          let workTypeSubsidesList = data.workTypeSubsidesList
          for (var i = 0; i < workTypeSubsidesList.length; i++) {
            var tempObj = {
              value: workTypeSubsidesList[i].subsidedMoney || 0,
              name: workTypeSubsidesList[i].workTypeName
            }
            this.typePieData.push(tempObj)
            typeBarName.push(workTypeSubsidesList[i].workTypeName)
            typeBarCurMoney.push(workTypeSubsidesList[i].subsidedMoney || 0)
            typeBarTotalMoney.push(workTypeSubsidesList[i].totalMoney || 0)
          }
        } else if (params.workTypeStatus == 2) {
          let workTypeAreaList = data.returnWorkTypeAreaList
          for (var i = 0; i < workTypeAreaList.length; i++) {
            var tempObj = {
              value: workTypeAreaList[i].subsidedWorkArea || 0,
              name: workTypeAreaList[i].workTypeName
            }
            this.typePieData.push(tempObj)
            typeBarName.push(workTypeAreaList[i].workTypeName)
            typeBarCurMoney.push(workTypeAreaList[i].subsidedWorkArea || 0)
            typeBarTotalMoney.push(workTypeAreaList[i].workArea || 0)
          }
        }
        this.typeBarData = {
          typeBarName: typeBarName,
          typeBarCurMoney: typeBarCurMoney,
          typeBarTotalMoney: typeBarTotalMoney
        }
        this.getTypePieChart()
        this.getTypeBarChart()
      })
    },
    /**
     * 切换作业类型查询补贴进度
     */
    changeJobType (e) {
      let id = parseInt(e.target.value)
      this.changeTypeProgress({workType: id})
    },
    /**
     * 作业补贴首页总的数据
     */
    getSubsidydata () {
      Api.doPost(Http.workSubsidy.workStatistics, null, false, (res) => {
        var data = res.result
        let susides = [
          {value: data.freeSusidesTotal, name: '剩余补贴资金总额'},
          {value: data.susidedTotal, name: '已补贴资金总额'}
        ]
        this.moneyChartdata = {
          susides: susides,
          susidedProportion: data.susidedProportion
        }
        console.log(this.moneyChartdata)
        let workTypeSubsidesList = data.workTypeSubsidesList
        let typeBarCurMoney = [], typeBarTotalMoney = [], typeBarName = []
        for (var i = 0; i < workTypeSubsidesList.length; i++) {
          var tempObj = {
            value: workTypeSubsidesList[i].subsidedMoney || 0,
            name: workTypeSubsidesList[i].workTypeName
          }
          this.typePieData.push(tempObj)
          typeBarName.push(workTypeSubsidesList[i].workTypeName)
          typeBarCurMoney.push(workTypeSubsidesList[i].subsidedMoney)
          typeBarTotalMoney.push(workTypeSubsidesList[i].totalMoney)
        }
        this.typeBarData = {
          typeBarName: typeBarName,
          typeBarCurMoney: typeBarCurMoney,
          typeBarTotalMoney: typeBarTotalMoney
        }
        this.typeProgressData = [
          {value: data.workTypePlanMap.auditMoney || 0, name: '待审核'},
          {value: data.workTypePlanMap.toPrintMoney || 0, name: '待打表'},
          {value: data.workTypePlanMap.publicMoney || 0, name: '公示中'},
          {value: data.workTypePlanMap.accountMoney || 0, name: '待结算'},
          {value: data.workTypePlanMap.accountedMoney || 0, name: '已结算'}
        ]
        let xDataJobALL = [], yDataJobALL = {}, driverList = [], orgList = [], deviceList = []
        for (var i = 0; i < data.difRegionsAgriDriverDistriList.length; i++) {
          xDataJobALL.push(data.difRegionsAgriDriverDistriList[i].name)
          driverList.push(data.difRegionsAgriDriverDistriList[i].num)
        }
        for (var i = 0; i < data.difRegionsAgriOrgDistriList.length; i++) {
          orgList.push(data.difRegionsAgriOrgDistriList[i].num)
        }
        for (var i = 0; i < data.difRegionsAgriDeviceDistriList.length; i++) {
          deviceList.push(data.difRegionsAgriDeviceDistriList[i].num)
        }
        yDataJobALL = {
          driverList: driverList,
          orgList: orgList,
          deviceList: deviceList
        }
        this.jobALLData = {
          xDataJobALL: xDataJobALL,
          yDataJobALL: yDataJobALL
        }
        this.getMoneyChart()
        this.getTypePieChart()
        this.getTypeBarChart()
        this.getTypeProgressChart()
        this.getJobALLChart()
      })
    },
    /**
     * 作业补贴类型列表
     */
    getWorkTypeList () {
      Api.doPost(Http.workSubsidy.workTypeList, null, false, (res) => {
        this.jobTypeList = res.result
        this.selectedJobType = this.jobTypeList[0].workType
      })
    },
    /**
     * 切换作业类型查询补贴进度数据
     * @param {object} workType 作业类型
     */
    changeTypeProgress (params) {
      Api.doPost(Http.workSubsidy.workTypePlan, params, false, (res) => {
        let data = res.result
        this.typeProgressData = [
          {value: data.auditMoney || 0, name: '待审核'},
          {value: data.toPrintMoney || 0, name: '待打表'},
          {value: data.publicMoney || 0, name: '公示中'},
          {value: data.accountMoney || 0, name: '待结算'},
          {value: data.accountedMoney || 0, name: '已结算'}
        ]
        this.getTypeProgressChart()
      })
    }
  },
  beforeDestroy () {
    // this.moneyChart.dispose()
    // this.typePieChart.dispose()
    // this.moneyChart = null
    // this.typePieChart = null
  }
}
</script>

<style scoped>
.box_style1 {
  /* width: 70%; */
  background-image: url('/static/img/zuoyejindu-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* position: relative; */
  height: 32vh;
  margin-bottom: 1vh;
}
.flex{
  display: flex;
}
.plate{
  width: 98%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.plate .title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  font-size: 20px;
  text-align: left;
  color: #fff;
}
.plate .title .small{
  font-size: 16px;
	color: #0c9be3;
}
.left-side{
  width: 66%;
}
.right-side{
  width: 33%;
}
.panel{
  padding: 0 20px;
}

.panel-map{
  padding: 0;
}
.panel-map .filter{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #0b61b3;
}
.panel-map .filter .title{
  display: inline-block;
  margin-right: 20px;
}
.panel-map .filter .item{
  height: 34px;
  padding: 0 10px;
  line-height: 34px;
  color: #0C9BE3;
  font-size:18px;
}
.panel-map .filter span.acvite{
  color: #fff;
  background: #0B61B3;
}
.panel-map .filter .account{
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #fff;
}
.panel-map .filter .account span{
  display: inline-block;
  width:35px;
  height:44px;
  margin-left: 5px;
  line-height: 44px;
  text-align: center;
  font-size: 35px;
  background:rgba(12,155,227,1);
  border-radius:4px;
}
.panel-map .filter .account span:nth-of-type(1){
  margin-left: 15px;
}
.panel-map .map{
  height: 60vh;
  margin-top: 0px;
  margin-bottom: 1vh;
}
.money-chart{
  width: 100%;
  height: 220px;
}
.panel-money{
  height: 27vh;
  margin-top: 1vh;
}
.panel-job{
  height: 65vh;
}
/* .panel-region{
  height: 26vh;
} */
.type-pic-chart{
  width: 35%;
  height: 22vh;
}
.type-bar-chart{
  width: 65%;
  height: 22vh;
}
.type-progress-chart{
  width: 100%;
  height: 22vh;
}
.unit{
  font-size: 16px;
  text-align: right;
	color: #0c9be3;
}
.toggle{
  margin: 0 auto 0 12px;
  margin-right: auto;
  border-radius: 3px;
  font-size: 0;
}
.toggle span{
  display: inline-block;
  height: 32px;
  padding: 0 12px;
  line-height: 32px;
  font-size: 16px;
	color: #fff;
  cursor: pointer;
  background-color: #2a1db6;
	border: solid 1px #2a1db6;
}
.toggle span.active{
  color: #2a1db6;
  background-color: #ffffff;
	border: solid 1px #2a1db6;

}
.select-type{
  width: 160px;
	height: 34px;
  line-height: 34px;
  font-size: 14px;
  color: #0c85e3;
  outline: none;
	background-color: #090c32;
	border-radius: 4px;
	border: solid 1px #0c85e3;
}
.panel-all{
  width: 100%;
  height: 360px;
}
.job-all-chart{
  height: 250px;
}
/* /deep/.tdt-left{
  display: none!important;
} */
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/JobSubsidy.vue